<template>
  <div :class="`snackbar ${variation}`">
    <CustomIcon v-if="icon" :name="computedIcon" />
    <slot></slot>
  </div>
</template>
<script>
import CustomIcon from "./CustomIcon.vue";
export default {
  name: "snackbar-prompt",
  props: {
    name: String,
    icon: String,
    variation: String,
  },
  components: { CustomIcon },
  computed: {
    computedIcon() {
      if (this.icon === "warning" && this.variation === "warning") {
        return "warning-white";
      }
      return this.icon;
    },
  },
};
</script>
